import { AgingStatusEnums, BillPaymentStatusEnums, BillStatusEnums, EstimateNewStatus, EstimateStatus, InvoiceStatus, ProductTransactionActionEnums, ProductTransactionIsActiveEnums, ProductTransactionStatusEnums, PurchaseOrderStatusEnums, VendorBillPaymentStatusEnums, VendorBillStatus, VendorCreditStatusEnums, VendorPaymentReceiptsStatusEnums, VendorRMAStatusEnums, VendorTransactionStageEnums} from "src/app/inventory/constants/constants";
import { SavedSearchNS } from "./saved-search.models";


export const SavedSearchParentModule = {
    Lead: "Lead",
    Account: "Account",
    Estimate: "Estimate",
    Invoice: "Invoice",
    Opportunity: "Opportunity",
} as const;

export type typeSavedSearchParentModule = typeof SavedSearchParentModule[keyof typeof SavedSearchParentModule];


//SavedSearch Column Data Types
export const SavedSearchColumnDataType = {
    number: 'number',
    currencySymbol: 'currencySymbol',
    percentageSymbol: 'percentageSymbol',
    number2dp: 'number2dp',
    boolean: 'boolean',
    string: 'string',
    date: 'date',
    datetime: 'datetime',
    secsdhms: 'secsdhms',
    timespan: 'timespan',
    undefined: 'undefined',
    null: 'null',
    popuplink: 'popuplink',
} as const;
export type typeSavedSearchColumnDataType = keyof typeof SavedSearchColumnDataType;

//SavedSearch Operator Types
// export type typeSavedSearchOperator = 'Is' | 'Is not' | 'Contains' | 'Does not contain';

//SavedSearch Choice Types
export type typeSavedSearchChoice = 'And' | 'Or';
export type typeSavedSearchBooleanValue = 'true' | 'false';
export type typeSavedSearchDisplayType = 'Add' | 'View' | 'Edit';

export const SavedSearchMessage = {
    errorMessageSaveSearchName: 'Saved Search Name Is Required',
    success: 'Success',
    saveSearchaveSuccessMsg: 'Saved Search saved successfully...',
    updateSearchaveSuccessMsg: 'Saved Search updated successfully...',
    saveSearchaveErrorMsg: 'Error occurred while saving Saved Search...',
    updateearchaveErrorMsg: 'Error occurred while updating Saved Search...',
    deleteconfirmationMessage: 'Do you want to delete this Saved Search?',
    deleteHeader: 'Delete Confirmation',
    deleteCircleIcon: 'pi pi-info-circle',
    savedSearchDeleteSuccessMsg: 'Saved Search Deleted successfully...',
    savedSearchDeleteErrorMsg: 'Error occurred while deleting data...',
    error: 'Error',
    saveSearchaveColSettngSuccessMsg: 'Saved Search column settings updated successfully...',
    saveSearchaveColSettngErrorMsg: 'Error occurred while updating column settings...',
    warning: 'Warn',
    exportconfirmationMessage: 'Do you want to export this Saved Search?',
    exportHeader: 'Export Confirmation',
    exportCircleIcon: 'pi pi-info-circle',
    removeHeader: 'Delete Confirmation',
    removeReportconfirmationMessage: 'Do you want to remove this saved search report?',
    savedSearchRemoveReportSuccessMsg: 'Saved Search report removed successfully...',
    savedSearchRemoveReportErrorMsg: 'Error occurred while removing data...',
} as const;

export const SavedSearchActiveInActiveStatus: Array<{id: number, name: string}> =
    [
        {id: 1, name: 'IsActive'},
        {id: 2, name: 'Inactive'},
        {id: 3, name: 'Deleted'}
    ]

export const SavedSearchOpportunityActiveInActiveStatus: Array<{id: number, name: string}> =
    [
        {id: 1, name: 'Active'},
        {id: 2, name: 'InActive'},
        {id: 3, name: 'Deleted'}
    ]

export const EstimateStatusObjects: Array<{ id: EstimateStatus, name: keyof typeof EstimateStatus }> =
    [
        { id: EstimateStatus.Open, name: 'Open' },
        { id: EstimateStatus.Processing, name: 'Processing' },
        { id: EstimateStatus.PartiallyFilled, name: 'PartiallyFilled' },
        { id: EstimateStatus.Completed, name: 'Completed' },
        { id: EstimateStatus.Hold, name: 'Hold' },
        { id: EstimateStatus.Void, name: 'Void' },
    ];

export const EstimateNewStatusObjects: Array<{ id: EstimateNewStatus, name: keyof typeof EstimateNewStatus }> =
    [
        { id: EstimateNewStatus.Draft, name: 'Draft' },
        { id: EstimateNewStatus.NeedsReview, name: 'NeedsReview' },
        { id: EstimateNewStatus.InReview, name: 'InReview' },
        { id: EstimateNewStatus.Approved, name: 'Approved' },
        { id: EstimateNewStatus.Rejected, name: 'Rejected' },
        { id: EstimateNewStatus.Presented, name: 'Presented' },
        { id: EstimateNewStatus.Accepted, name: 'Accepted' },
        { id: EstimateNewStatus.Denied, name: 'Denied' },
        { id: EstimateNewStatus.Void, name: 'Void' },
    ];

export const InvoiceStatusObjects: Array<{ id: InvoiceStatus, name: keyof typeof InvoiceStatus }> =
    [
        { id: InvoiceStatus.Processing, name: 'Processing' },
        { id: InvoiceStatus.Completed, name: 'Completed' },
        { id: InvoiceStatus.Hold, name: 'Hold' },
        { id: InvoiceStatus.Void, name: 'Void' },
        { id: InvoiceStatus.Cancel, name: 'Cancel' },
    ];

export const TaxPreferenceObjects: Array<{value: boolean, name: string}> =
[
    { value: true, name: 'Yes' },
    { value: false, name: 'No' }
];

export const ParentModules: Array<SavedSearchNS.IObjectType> = [
    { id: 1, objectId: 1, name: 'Lead', isMainModule: true, statusId: 1, childobject: [] },
    { id: 2, objectId: 2, name: 'Account', isMainModule: true, statusId: 1, childobject: [] },
    { id: 3, objectId: 244, name: 'Estimate', isMainModule: true, statusId: 1, childobject: [] },
    { id: 4, objectId: 266, name: 'Invoice', isMainModule: true, statusId: 1, childobject: [] },
    { id: 5, objectId: 3, name: 'Opportunity', isMainModule: true, statusId: 1, childobject: [] },
];

export enum OrderStatus {
    ReadyToPick = 1,
    Processing = 2,
    Hold = 3,
    Cancel = 4,
    BackOrder = 5,
    ReadyToPack = 6,
    Labelled = 7,
    Verified = 8,
    ReadyToShip = 9,
    Fulfilled = 10,
    Void = 11,
    Entered = 12
}

export const OrderStatusObjects: Array<{ id: OrderStatus, name: string }> = [
    { id: OrderStatus.ReadyToPick, name: 'Ready To Pick' },
    { id: OrderStatus.Processing, name: 'Processing' },
    { id: OrderStatus.Hold, name: 'Hold' },
    { id: OrderStatus.Cancel, name: 'Cancel' },
    { id: OrderStatus.BackOrder, name: 'BackOrder' },
    { id: OrderStatus.ReadyToPack, name: 'Ready To Pack' },
    { id: OrderStatus.Labelled, name: 'Labelled' },
    { id: OrderStatus.Verified, name: 'Verified' },
    { id: OrderStatus.ReadyToShip, name: 'ReadyToShip' },
    { id: OrderStatus.Fulfilled, name: 'Fulfilled' },
    { id: OrderStatus.Void, name: 'Void' },
    { id: OrderStatus.Entered, name: 'Entered' }
];


export const OppForecastCategory: Array<{ }> =
    [
        {id: 1, name: 'Pipeline' },
        {id: 2, name: 'Closed Won' },
        {id: 3, name: 'Closed Lost' },
    ];

export enum InvoicePaymentStatusEnum {
    Open = 1,
    Paid = 2,
    PartiallyPaid = 3,
}
export const InvoicePaymentStatusEnumObjects: Array<{ id: InvoicePaymentStatusEnum, name: keyof typeof InvoicePaymentStatusEnum }> =
    [
        { id: InvoicePaymentStatusEnum.Open, name: 'Open' },
        { id: InvoicePaymentStatusEnum.Paid, name: 'Paid' },
        { id: InvoicePaymentStatusEnum.PartiallyPaid, name: 'PartiallyPaid' },
    ];

export enum SalesOrderStatusEnum {
   Entered =1,
   ReadyToPick =2,
   ReadyToPack=3,
   Fulfilled =4,
   Processing =5,
   Hold =6,
   Cancel =7,
   BackOrder=8,
   Labelled=9,
   Verified= 10
}
export const SalesOrderStatusEnumObjects: Array<{ id: SalesOrderStatusEnum, name: keyof typeof SalesOrderStatusEnum }> =
        [
            { id: SalesOrderStatusEnum.Entered, name: 'Entered' },
            { id: SalesOrderStatusEnum.ReadyToPick, name: 'ReadyToPick' },
            { id: SalesOrderStatusEnum.ReadyToPack, name: 'ReadyToPack' },
            { id: SalesOrderStatusEnum.ReadyToPack, name: 'Fulfilled' },
            { id: SalesOrderStatusEnum.ReadyToPack, name: 'Processing' },
            { id: SalesOrderStatusEnum.ReadyToPack, name: 'Hold' },
            { id: SalesOrderStatusEnum.ReadyToPack, name: 'Cancel' },
            // { id: SalesOrderStatusEnum.ReadyToPack, name: 'BackOrder' },
            { id: SalesOrderStatusEnum.Labelled, name: 'Labelled' },
            { id: SalesOrderStatusEnum.Verified, name: 'Verified' }
];

export enum SalesOrderStageEnum {
    Ship=4,
    Pack=3,
    Pick=2,
    Entered=1,
    Labelling=5,
    Verification= 6,
    ReadyToShip=7
 }
 export const SalesOrderStageEnumObjects: Array<{ id: SalesOrderStageEnum, name: keyof typeof SalesOrderStageEnum }> =
         [
             { id: SalesOrderStageEnum.Entered, name: 'Entered' },
             { id: SalesOrderStageEnum.Pick, name: 'Pick' },
             { id: SalesOrderStageEnum.Pack, name: 'Pack' },
             { id: SalesOrderStageEnum.Ship, name: 'Ship' },
             { id: SalesOrderStageEnum.Labelling, name: 'Labelling' },
             { id: SalesOrderStageEnum.Verification, name: 'Verification' },
             { id: SalesOrderStageEnum.ReadyToShip, name: 'ReadyToShip' }
 ];


export enum ShipmentStatus {
    Pre_Transit = "We're sorry this package has experienced a sortation delay. The package has been rerouted to the correct destination.",
    Tr_Delivered = "We tried to deliver to the business, but it was closed. A second attempt will be made the next business day.",
    Departed_Facility = "Departed from Facility",
    Arrived_Facility = "Arrived at Facility",
    Processing_Facility = "Processing at UPS Facility",
    In_Transit = 'in_transit',
    Delivered = 'Delivered',
    Shipper_Created = 'Shipper created a label, UPS has not received the package yet.'
}
export const ShipmentStatusObjects: Array<{ id: number, name: ShipmentStatus }> =
    [
        { id: 1, name: ShipmentStatus.Pre_Transit, },
        { id: 2, name: ShipmentStatus.Tr_Delivered, },
        { id: 3, name: ShipmentStatus.Departed_Facility, },
        { id: 4, name: ShipmentStatus.Arrived_Facility, },
        { id: 5, name: ShipmentStatus.Processing_Facility, },
        { id: 6, name: ShipmentStatus.In_Transit, },
        { id: 7, name: ShipmentStatus.Shipper_Created, },
        { id: 8, name: ShipmentStatus.Delivered, },
    ];

export enum TransactionTypeEnum {
        Invoice = 1,
        SalesOrder = 2,
        CreditMemo = 7,
        Estimate = 8,
        CustomerRMA = 9,
        PurchaseOrder = 10,
        BillOrder = 11,
        VendorRMA = 12,
        VendorCredit = 13,
        BillPayment = 14
    }
 export const TransactionTypes: Array<{ id: TransactionTypeEnum, name: string }> =
    [
        { id: TransactionTypeEnum.Estimate, name: 'Estimates' },
        { id: TransactionTypeEnum.SalesOrder, name: 'Sales Order' },
        { id: TransactionTypeEnum.Invoice, name: 'Invoice' },
        { id: TransactionTypeEnum.CustomerRMA, name: 'Customer Returns' },
        { id: TransactionTypeEnum.CreditMemo, name: 'Credit Memo' },
    ];

    export const VendorTransactionTypes: Array<{ id: TransactionTypeEnum, name: string }> =
    [
        { id: TransactionTypeEnum.PurchaseOrder, name: 'Purchase Order' },
        { id: TransactionTypeEnum.BillOrder, name: 'Bill Order' },
        { id: TransactionTypeEnum.VendorRMA, name: ' Vendor RMA' },
        { id: TransactionTypeEnum.VendorCredit, name: 'Vendor Credit' },
        { id: TransactionTypeEnum.BillPayment, name: 'Payment Receipts' },
        
    ];

    export const ProductTransactionStatus: Array<{ id: ProductTransactionStatusEnums, name: string}> =
    [
        { id: ProductTransactionStatusEnums.Bill, name: 'Bill' },
        { id: ProductTransactionStatusEnums.CreditCharges, name: 'CreditCharges' },
        { id: ProductTransactionStatusEnums.VendorCredit, name: 'VendorCredit' },
        { id: ProductTransactionStatusEnums.CustomerRMA, name: 'CustomerRMA' },
        { id: ProductTransactionStatusEnums.Check, name: 'Check' },
        { id: ProductTransactionStatusEnums.Invoice, name: 'Invoice' },
        { id: ProductTransactionStatusEnums.CreditMemo, name: 'Credit Memo' },
        { id: ProductTransactionStatusEnums.InventoryAdjustment, name: 'Inventory Adjustment' },
        { id: ProductTransactionStatusEnums.VendorRMA, name: 'VendorRMA' },
        { id: ProductTransactionStatusEnums.Expense, name: 'Expense' },  
        { id: ProductTransactionStatusEnums.InventoryTransfer, name: 'Inventory Transfer' },
        { id: ProductTransactionStatusEnums.ItemReceipt, name: 'Item Receipt' }

    ];

    export const ProductTransactionAction: Array<{ id: ProductTransactionActionEnums, name: string}> =
    [
        { id: ProductTransactionActionEnums.Update, name: 'Update' },
        { id: ProductTransactionActionEnums.Add, name: 'Add' },
        { id: ProductTransactionActionEnums.Create, name: 'Create' },
        { id: ProductTransactionActionEnums.Delete, name: 'Delete' },
    ];

export const DateTimeOperatorValue = [
    { label: 'Today', code: 'today' },
    { label: 'Yesterday', code: 'yesterday' },
    { label: 'This Month', code: 'thismonth' },
    { label: 'Last Month', code: 'lastmonth' },
    { label: 'Last 7 days', code: 'last7days' },
    { label: 'Last 15 days', code: 'last15days' },
    { label: 'Last 30 days', code: 'last30days' },
    { label: 'Last 60 days', code: 'last60days' },
    { label: 'Last 90 days', code: 'last90days' },
    { label: 'Custom', code: 'custom' },
];

export const RatingValueObjects: Array<{ id: number, name: number }> =
    [
        { id: 1, name: 1, },
        { id: 2, name: 2, },
        { id: 3, name: 3, },
        { id: 4, name: 4, },
        { id: 5, name: 5, },
    ];


export namespace DataTypeWithOperatorNS {

    export type typeDataTypes = 'String' | 'Number' | 'Decimal' | 'Boolean' | 'DateTime' | 'Time' | 'Enum' | 'Distance' | 'Money';
    export type typeValueDataTypes = 'String' | 'Number' | 'Decimal' | 'Boolean' | 'DateTime' | 'Time' | 'Enum' | 'User' | 'Country' | 'DropdownList' | 'MultiSelect' | 'MultiSelectAPI' | 'Year' | 'TreeSelect' | 'Distance' | 'AutoCompleteDropdown' | 'Rating' | 'Money';
    export type typeNoOfValuesToBePassed = 'No_Value' | 'Single_Value' | 'Between_Value' | 'Multiple';
    export type typeOperator = 'IsEqualTo' | 'IsNotEqualTo' | 'StartsWith' | 'EndsWith' | 'Contains' | 'DoesNotContain' | 'HasValue' | 'NoValue' | 'Is' | 'NotOn' | 'Between' | 'NotBetween' | 'Before' | 'After' | 'OnOrBefore' | 'OnOrAfter' | 'IsGreaterThan' | 'IsLessThan' | 'IsGreaterThanEqualTo' | 'IsLessThanEqualTo' | 'Within' | 'Outside';

    export interface ISavedSearchDataTypeWithOperator {
        DataType: typeDataTypes;
        Operator: typeOperator;
        NoOfValuesToBePassed: typeNoOfValuesToBePassed;
    }

    export const SavedSearchDataTypeWithOperator: ISavedSearchDataTypeWithOperator[] =
        [
            {
                DataType: "Boolean",
                Operator: "IsEqualTo",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Boolean",
                Operator: "IsNotEqualTo",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "DateTime",
                Operator: "Is",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "DateTime",
                Operator: "NotOn",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "DateTime",
                Operator: "Between",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "DateTime",
                Operator: "NotBetween",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "DateTime",
                Operator: "Before",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "DateTime",
                Operator: "After",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "DateTime",
                Operator: "OnOrBefore",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "DateTime",
                Operator: "OnOrAfter",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Time",
                Operator: "Is",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Time",
                Operator: "NotOn",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Time",
                Operator: "Between",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "Time",
                Operator: "NotBetween",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "Time",
                Operator: "Before",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Time",
                Operator: "After",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Time",
                Operator: "OnOrBefore",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Time",
                Operator: "OnOrAfter",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Number",
                Operator: "IsEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Number",
                Operator: "IsNotEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Number",
                Operator: "StartsWith",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Number",
                Operator: "EndsWith",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Number",
                Operator: "Contains",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Number",
                Operator: "DoesNotContain",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Number",
                Operator: "Between",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "Number",
                Operator: "NotBetween",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "Number",
                Operator: "IsGreaterThan",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Number",
                Operator: "IsLessThan",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Number",
                Operator: "IsGreaterThanEqualTo",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Number",
                Operator: "IsLessThanEqualTo",
                NoOfValuesToBePassed: "Single_Value"
            },
            //
            {
                DataType: "Decimal",
                Operator: "IsEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Decimal",
                Operator: "IsNotEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Decimal",
                Operator: "StartsWith",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Decimal",
                Operator: "EndsWith",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Decimal",
                Operator: "Contains",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Decimal",
                Operator: "DoesNotContain",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Decimal",
                Operator: "Between",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "Decimal",
                Operator: "NotBetween",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "Decimal",
                Operator: "IsGreaterThan",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Decimal",
                Operator: "IsLessThan",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Decimal",
                Operator: "IsGreaterThanEqualTo",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Decimal",
                Operator: "IsLessThanEqualTo",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Money",
                Operator: "IsEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Money",
                Operator: "IsNotEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Money",
                Operator: "StartsWith",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Money",
                Operator: "EndsWith",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Money",
                Operator: "Contains",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Money",
                Operator: "DoesNotContain",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Money",
                Operator: "Between",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "Money",
                Operator: "NotBetween",
                NoOfValuesToBePassed: "Between_Value"
            },
            {
                DataType: "Money",
                Operator: "IsGreaterThan",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Money",
                Operator: "IsLessThan",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Money",
                Operator: "IsGreaterThanEqualTo",
                NoOfValuesToBePassed: "Single_Value"
            },
            {
                DataType: "Money",
                Operator: "IsLessThanEqualTo",
                NoOfValuesToBePassed: "Single_Value"
            },
            //
            {
                DataType: "String",
                Operator: "IsEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "String",
                Operator: "IsNotEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "String",
                Operator: "StartsWith",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "String",
                Operator: "EndsWith",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "String",
                Operator: "Contains",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "String",
                Operator: "DoesNotContain",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "String",
                Operator: "HasValue",
                NoOfValuesToBePassed: "No_Value"
            },
            {
                DataType: "String",
                Operator: "NoValue",
                NoOfValuesToBePassed: "No_Value"
            },
            {
                DataType: "Enum",
                Operator: "IsEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Enum",
                Operator: "IsNotEqualTo",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Enum",
                Operator: "HasValue",
                NoOfValuesToBePassed: "No_Value"
            },
            {
                DataType: "Enum",
                Operator: "NoValue",
                NoOfValuesToBePassed: "No_Value"
            },
            {
                DataType: "Distance",
                Operator: "Within",
                NoOfValuesToBePassed: "Multiple"
            },
            {
                DataType: "Distance",
                Operator: "Outside",
                NoOfValuesToBePassed: "Multiple"
            }
        ];

        
}

    export const VendorAllBillStatus: Array<{ id: VendorBillStatus, name: keyof typeof VendorBillStatus }> =
    [
        { id: VendorBillStatus.Pending, name: 'Pending' },
        { id: VendorBillStatus.Partial, name: 'Partial' },
        { id: VendorBillStatus.Full, name: 'Full' },
        { id: VendorBillStatus.Voided, name: 'Voided' },
        { id: VendorBillStatus.Created, name: 'Created' },
        
    ];

    export const PurchaseOrderIsActive: Array<{ id: ProductTransactionIsActiveEnums, name: keyof typeof ProductTransactionIsActiveEnums }> =
    [
        { id: ProductTransactionIsActiveEnums.Yes, name: 'Yes' },
        { id: ProductTransactionIsActiveEnums.No, name: 'No' },
        
    ];

    export const PurchaseOrderStatus: Array<{ id: PurchaseOrderStatusEnums, name: keyof typeof PurchaseOrderStatusEnums }> =
    [
        { id: PurchaseOrderStatusEnums.Open, name: 'Open' },
        { id: PurchaseOrderStatusEnums.Processing, name: 'Processing' },
        { id: PurchaseOrderStatusEnums.PartiallyFilled, name: 'PartiallyFilled' },
        { id: PurchaseOrderStatusEnums.Completed, name: 'Completed' },
        { id: PurchaseOrderStatusEnums.Hold, name: 'Hold' },
        { id: PurchaseOrderStatusEnums.Void, name: 'Void' },
        
    ];

    export const VendorRMAStatus: Array<{ id: VendorRMAStatusEnums, name: keyof typeof VendorRMAStatusEnums }> =
    [
        { id: VendorRMAStatusEnums.Initiation, name: 'Initiation' },
        { id: VendorRMAStatusEnums.Sent, name: 'Sent' },
        { id: VendorRMAStatusEnums.Approved, name: 'Approved' },
        { id: VendorRMAStatusEnums.Declined, name: 'Declined' },
        { id: VendorRMAStatusEnums.Void, name: 'Void' },

        
    ];

    export const VendorCreditStatus: Array<{ id: VendorCreditStatusEnums, name: keyof typeof VendorCreditStatusEnums }> =
    [
        { id: VendorCreditStatusEnums.Open, name: 'Open' },
        { id: VendorCreditStatusEnums.Applied, name: 'Applied' },
        { id: VendorCreditStatusEnums.PartiallyApplied, name: 'PartiallyApplied' },
        { id: VendorCreditStatusEnums.Paid, name: 'Paid' },
        { id: VendorCreditStatusEnums.Void, name: 'Void' },

        
    ];

    export const VendorTransactionStage: Array<{ id: VendorTransactionStageEnums, name: keyof typeof VendorTransactionStageEnums }> =
    [
        { id: VendorTransactionStageEnums.Entered, name: 'Entered' },
        { id: VendorTransactionStageEnums.Issued, name: 'Issued' },
        { id: VendorTransactionStageEnums.ReceiveInventory, name: 'ReceiveInventory' },
        { id: VendorTransactionStageEnums.Closed, name: 'Closed' },
        
    ];

    export const VendorBillPaymentStatus: Array<{ id: VendorBillPaymentStatusEnums, name: keyof typeof VendorBillPaymentStatusEnums }> =
    [
        { id: VendorBillPaymentStatusEnums.Paid, name: 'Paid' },
        { id: VendorBillPaymentStatusEnums.Voided, name: 'Voided' },
        
    ];

    export const VendorPaymentReceiptsStatus: Array<{ id: VendorPaymentReceiptsStatusEnums, name: keyof typeof VendorPaymentReceiptsStatusEnums }> =
    [
        { id: VendorPaymentReceiptsStatusEnums.Open, name: 'Open' },
        { id: VendorPaymentReceiptsStatusEnums.PartiallyPaid, name: 'PartiallyPaid' },
        
    ];
    
    export const BillStatus: Array<{ id: BillStatusEnums, name: keyof typeof BillStatusEnums }> =
    [
        { id: BillStatusEnums.Created, name: 'Created' },
        { id: BillStatusEnums.Voided, name: 'Voided' },
        
    ];

    export const BillPaymentStatus: Array<{ id: BillPaymentStatusEnums, name: keyof typeof BillPaymentStatusEnums }> =
    [
        { id: BillPaymentStatusEnums.Open, name: 'Open' },
        { id: BillPaymentStatusEnums.Paid, name: 'Paid' },
        { id: BillPaymentStatusEnums.PartiallyPaid, name: 'PartiallyPaid' },
        
    ];

    export const AgingStatus: Array<{ id: AgingStatusEnums; name: string }> = [
        { id: AgingStatusEnums.Current, name: 'Current' },
        { id: AgingStatusEnums.Days31to60, name: '31–60 Days' },
        { id: AgingStatusEnums.Days61to90, name: '61–90 Days' },
        { id: AgingStatusEnums.Days91plus, name: '91+ Days' },
      ];
      
